// Pure slug helpers — no data import, safe to use in client components.

export const OPEN_SLUG = 'open';

/** Canonical pair slug (SEO-1): Open first on type2, else alphabetical. */
export function canonicalPairSlug(aSlug: string, bSlug: string): string {
  if (aSlug === OPEN_SLUG || bSlug === OPEN_SLUG) {
    const other = aSlug === OPEN_SLUG ? bSlug : aSlug;
    return `${OPEN_SLUG}-vs-${other}`;
  }
  const [x, y] = [aSlug, bSlug].sort();
  return `${x}-vs-${y}`;
}

export function comparePath(vertical: string, slug: string): string {
  return `/compare/${vertical}/${slug}`;
}

/** Parse a `{a}-vs-{b}` slug into its two URL tokens, or null if malformed. */
export function parsePairSlug(slug: string): [string, string] | null {
  const parts = slug.split('-vs-');
  if (parts.length !== 2 || !parts[0] || !parts[1]) return null;
  return [parts[0], parts[1]];
}
